<template>
	<span class="loader-icon">
		<svg :width="size+'px'"  :height="size+'px'"   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-infinity" style="background: none;">
		<path fill="none" d="M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40 C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z" :stroke="color" stroke-width="11" stroke-dasharray="243.75948181152344 12.829446411132807">
			<animate attributeName="stroke-dashoffset" calcMode="linear" values="0;256.58892822265625" keyTimes="0;1" dur="1" begin="0s" repeatCount="indefinite"></animate>
		</path>
	</svg>
	</span>
</template>

<script>
	export default {
		name: "loader",
		props: {
			color:{
				type: String,
				default: '#11bcd8'
			},
			size:{
				type: Number,
				default: 80
			}
		},
		computed:{

		}
	}
</script>
<style lang="scss">
	.loader-icon{
		display: inline-block;
		margin-right: 5px;
		position: relative;

	}
	.btn{
		>.loader-icon{
			top: -2px;

		}
	}
</style>
